/*
FEATURE: subscriptions        STATUS: optional
COST: 4,063 B JS direct (1,262 B gzip; 11,314 B cold closure)
PROVIDES: Selling-plan selection on product and cart surfaces
REQUIRES: Shopify selling plans matching the starter group mapping
HOOKS: sections/main-product.liquid and snippets/cart-drawer-items.liquid
SETTINGS: settings.enable_subscriptions
REMOVE: docs/optional-features/subscriptions.md
*/
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { CartSubscription } from '@/scripts/cart/cart-subscription'
import { SubscriptionWidget } from '@/scripts/product/subscription'

q.safeDefineElement(CartSubscription)
q.safeDefineElement(SubscriptionWidget)
